export { default } from 'create-react-class';